import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import MdSettings from 'react-icons/lib/md/settings';

import { media } from '../../../../styles';

import SelectField from '../../../ui/SelectField';
import Body from '../../../typography/Body';
import Caption from '../../../typography/Caption';

import TaraFiltersBlock from './TaraFiltersBlock';

const FilterButton = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 2,
  padding: 8,
  borderTop: `1px solid ${props.theme.default.lightest}`,
  borderRight: props.hasBorderRight ? `1px solid ${props.theme.default.lightest}` : undefined,
  backgroundColor: '#fff',

  cursor: 'pointer',
  userSelect: 'none',

  [media('sm')]: {
    borderTop: 'none',

    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  },
}));

const FiltersBlockRow = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderBottom: `1px solid ${props.theme.default.lightest}`,
}));

const SortContainer = glamorous.div(props => ({
  borderBottom: `1px solid ${props.theme.default.lightest}`,
}));

const Col = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
});

const styleTara = {
  transformOriginY: '100%',
  transition: 'transform 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
};
const styleHideTara = {
  ...styleTara,
  overflow: 'hidden',
  height: 0,
  transform: 'scaleY(0)',
};

class FiltersBlock extends React.PureComponent {
  static propTypes = {
    priceLow: PropTypes.number,
    priceHigh: PropTypes.number,
    shouldShowAllTickets: PropTypes.bool,
  };

  static defaultProps = {
    priceLow: 1,
    priceHigh: 5,
    shouldShowAllTickets: false,
  };

  get priceDisplay() {
    const {
      priceLow,
      priceHigh,
    } = this.props;

    return `${new Array(priceLow + 1).join('$')} - ${new Array(priceHigh + 1).join('$')}`;
  }

  get quantityDisplay() {
    const {
      quantity,
    } = this.props;

    return (!quantity || quantity === 'any') ? 'Any Quantity' : quantity;
  }

  get browsingAllDisplay() {
    const { ticketList, isFetching } = this.props;

    if (isFetching) {
      return (<span>&hellip;</span>);
    }

    return ticketList.length;
  }

  renderTaraFilters() {
    return (
      <div
        style={this.props.isViewingMap ? styleHideTara : styleTara}
      >
        <TaraFiltersBlock
          onClick={this.props.onClickFilters}
          quantity={this.props.quantity}
          persona={this.props.persona}
          mapStatus={this.props.mapStatus}
          isFetching={this.props.isFetching}
          ticketList={this.props.ticketList}
          hasNoRecommendedTickets={this.props.hasNoRecommendedTickets}
          shouldShowAllTickets={this.props.shouldShowAllTickets}
          eventName={this.props.eventName}
          venue={this.props.venue}
        />
      </div>
    );
  }

  renderDefaultFilters() {
    return (
      <FiltersBlockRow>
        <FilterButton
          hasBorderRight
          onClick={this.props.onClickFilters}
        >
          <Caption>Quantity</Caption>
          <Body marginBottom={0} weight={400} fontSize="0.85em">{this.quantityDisplay}</Body>
        </FilterButton>

        <FilterButton
          hasBorderRight
          onClick={this.props.onClickFilters}
        >
          <Caption>Price Range</Caption>
          <Body marginBottom={0} weight={400} fontSize="0.85em">{this.priceDisplay}</Body>
        </FilterButton>

        <FilterButton onClick={this.props.onClickFilters}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <Caption>More Filters</Caption>
            <MdSettings color="#e0e0e0" size={16} />
          </div>
        </FilterButton>
      </FiltersBlockRow>
    );
  }

  renderBrowsingAllFilters() {
    return (
      <FiltersBlockRow>
        <FilterButton
          hasBorderRight
          onClick={this.props.onClickFilters}
        >
          <Caption>Tickets Available</Caption>
          <Body marginBottom={0} weight={400} fontSize="0.85em">{this.browsingAllDisplay}</Body>
        </FilterButton>

        <FilterButton onClick={this.props.onClickFilters}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <Caption>Filters</Caption>
            <MdSettings color="#e0e0e0" size={16} />
          </div>
        </FilterButton>
      </FiltersBlockRow>
    );
  }

  renderFilters() {
    if (this.props.hasTaraFilters) {
      return this.renderTaraFilters();
    }

    if (this.props.hasFilters) {
      return this.renderDefaultFilters();
    }

    return null;
  }

  renderSort() {
    const { sortOptions } = this.props;

    return (
      <SortContainer>
        <SelectField
          isBorderless
          name="Sort"
          placeholder="Sort by..."
          onChange={this.props.onChangeSort}
          defaultSelected={this.props.seaticsFilterOptions.sortType}
          options={Object.keys(sortOptions).map(key => ({ value: key, label: sortOptions[key].name }))}
        />
      </SortContainer>
    );
  }

  render() {
    const {
      hasSort,
      hasTaraFilters,
      shouldShowAllTickets,
    } = this.props;

    return (
      <Col>
        {(shouldShowAllTickets && !hasTaraFilters) ? this.renderBrowsingAllFilters() : this.renderFilters()}
        {hasSort && this.renderSort()}
      </Col>
    );
  }
}

export default FiltersBlock;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/FiltersBlock.js